import TwoRow from "./TwoRow";

export default TwoRow;
